import { InteractionRequiredAuthError } from '@azure/msal-browser';

const graphCalendarRequest = {
  scopes: ['Calendars.ReadWrite'],
};

/**
 * Acquire a Microsoft Graph access token with Calendars.ReadWrite scope.
 * Triggers incremental consent popup if the user hasn't consented yet.
 * Returns the access token string, or null if acquisition fails.
 */
export async function getGraphCalendarToken(msalInstance, account) {
  if (!account) return null;

  try {
    const response = await msalInstance.acquireTokenSilent({
      ...graphCalendarRequest,
      account,
    });
    return response.accessToken;
  } catch (err) {
    if (err instanceof InteractionRequiredAuthError) {
      try {
        const response = await msalInstance.acquireTokenPopup({
          ...graphCalendarRequest,
          account,
        });
        return response.accessToken;
      } catch (popupErr) {
        console.warn('User declined calendar consent or popup blocked:', popupErr.message);
        return null;
      }
    }
    console.warn('Failed to acquire Graph calendar token:', err.message);
    return null;
  }
}

const graphContactsRequest = {
  scopes: ['Contacts.ReadWrite'],
};

const graphMailRequest = {
  scopes: ['Mail.Read'],
};

/**
 * Acquire a Microsoft Graph access token with Contacts.ReadWrite scope.
 * Triggers incremental consent popup if the user hasn't consented yet.
 * Returns the access token string, or null if acquisition fails.
 */
export async function getGraphContactsToken(msalInstance, account) {
  if (!account) return null;

  try {
    const response = await msalInstance.acquireTokenSilent({
      ...graphContactsRequest,
      account,
    });
    return response.accessToken;
  } catch (err) {
    if (err instanceof InteractionRequiredAuthError) {
      try {
        const response = await msalInstance.acquireTokenPopup({
          ...graphContactsRequest,
          account,
        });
        return response.accessToken;
      } catch (popupErr) {
        console.warn('User declined contacts consent or popup blocked:', popupErr.message);
        return null;
      }
    }
    console.warn('Failed to acquire Graph contacts token:', err.message);
    return null;
  }
}

/**
 * Acquire a Microsoft Graph access token with Mail.Read scope.
 * Triggers incremental consent popup if the user hasn't consented yet.
 * Returns the access token string, or null if acquisition fails.
 */
export async function getGraphMailToken(msalInstance, account) {
  if (!account) return null;

  try {
    const response = await msalInstance.acquireTokenSilent({
      ...graphMailRequest,
      account,
    });
    return response.accessToken;
  } catch (err) {
    if (err instanceof InteractionRequiredAuthError) {
      try {
        const response = await msalInstance.acquireTokenPopup({
          ...graphMailRequest,
          account,
        });
        return response.accessToken;
      } catch (popupErr) {
        console.warn('User declined mail consent or popup blocked:', popupErr.message);
        return null;
      }
    }
    console.warn('Failed to acquire Graph mail token:', err.message);
    return null;
  }
}

const graphMailSendRequest = {
  scopes: ['Mail.Send'],
};

/**
 * Acquire a Microsoft Graph access token with Mail.Send scope.
 * Triggers incremental consent popup if the user hasn't consented yet.
 * Returns the access token string, or null if acquisition fails.
 */
export async function getGraphMailSendToken(msalInstance, account) {
  if (!account) return null;

  try {
    const response = await msalInstance.acquireTokenSilent({
      ...graphMailSendRequest,
      account,
    });
    return response.accessToken;
  } catch (err) {
    if (err instanceof InteractionRequiredAuthError) {
      try {
        const response = await msalInstance.acquireTokenPopup({
          ...graphMailSendRequest,
          account,
        });
        return response.accessToken;
      } catch (popupErr) {
        console.warn('User declined mail send consent or popup blocked:', popupErr.message);
        return null;
      }
    }
    console.warn('Failed to acquire Graph mail send token:', err.message);
    return null;
  }
}
